const NotFound = () => {
  return (
    <h2>
      Страницата не е открита!
    </h2>
  )
}

export default NotFound
